import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserComplexPaintDemo from 'src/games/demos/phaserComplexPaintDemo/Main';

interface ComplexPaintDemoProps extends PageProps<{}> {
}

class ComplexPaintDemo extends React.Component<ComplexPaintDemoProps> {
    constructor(props: ComplexPaintDemoProps) {
        super(props);
        bindAllOfThis(this, ComplexPaintDemo.prototype);
    }

    render() {
        return <div>
            <PhaserComplexPaintDemo />
        </div>;
    }
}

export default ComplexPaintDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/ComplexPaintDemo.tsx